import {
    FlexBox,
    Title,
    Slider,
    Text,
} from '@ui5/webcomponents-react';
import { EstInfoButton } from './EstInfoButton';
import { spacing } from "@ui5/webcomponents-react-base";

export function EstOutputLine(props) {

    return (
        <>
            <FlexBox
                alignItems="Start"
                direction="Row"
                justifyContent="SpaceBetween"
                wrap="NoWrap"
            >
                <FlexBox
                    alignItems="Start"
                    direction="Row"
                    style={{ width: "70%" }}
                >
                                      <Text style={{ textAlign: "start", ...spacing.sapUiContentPadding }} >
                        {props.title}                            </Text>


                    <EstInfoButton
                        header={props.title}
                        text={props.infoText}
                        iconId={props.id + "-icon"}
                        iconStyle={{ ...spacing.sapUiContentPadding }}>

                    </EstInfoButton>

                </FlexBox>
                <Text style={{ width: "30%", ...spacing.sapUiContentPadding }}>{props.formatter ? props.formatter(props.value) : props.value}</Text>

            </FlexBox>

        </>
    )

}